<template>
  <!-- 打印最终唛头 -->
  <div>
    <div class="main" id="print" ref="print">
      <div class="content">
        <div class="top">
          <div class="top-title">
            <div class="title-left" v-if="detail.user">{{ detail.user.realname }}</div>
            <div class="title-right">{{ getDate() }}</div>
          </div>
          <div class="top-text" v-if="detail.order_sn">{{ detail.order_sn.split('-')[0].substr(0,
            detail.order_sn.split('-')[0].length - 4) }}
            <br>{{ detail.order_sn.split('-')[0].substr(detail.order_sn.split('-')[0].length - 4) }}-{{
              detail.order_sn.split('-')[1] }}-{{
              detail.box_no }}
          </div>
        </div>
        <div class="middle">
          <div>業務担当：{{ detail.y_name }}</div>
          <div>捆包担当：{{ detail.p_name }}</div>
        </div>
        <div class="footer">
          <div class="box-info">
            <span>NO .{{ detail.box_no }} ({{ detail.weight }}KG)</span>
          </div>
          <div>{{ detail.c }} * {{ detail.k }} * {{ detail.g }} CM</div>
          <!-- 箱子主档 ID 一维码，与箱号区分；SVG 可直接复制到打印窗口。 -->
          <svg v-show="detail.id" ref="boxBarcode" class="box-barcode"></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDate } from "@/utlis/date";
export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      getDate
    }
  },
  mounted() {
    this.getBoxBarcode()
  },
  watch: {
    // SVG 始终保留，切换箱子时同步更新，确保父级 nextTick 打印拿到当前箱子的条码。
    'detail.id'() {
      this.getBoxBarcode()
    }
  },
  methods: {
    // 沿用项目 JsBarcode，编码内容只使用箱子 ID，不使用订单号或箱号。
    getBoxBarcode() {
      if (!this.$refs.boxBarcode || !this.detail.id) return
      this.$JsBarcode(this.$refs.boxBarcode, String(this.detail.id), {
        format: 'CODE128',
        displayValue: true,
        width: 5,
        height: 150,
        fontSize: 38,
        font: 'Arial',
        fontOptions: 'bold',
        textMargin: 6,
        margin: 40,
        marginTop: 6,
        marginBottom: 6,
        lineColor: '#000000',
        background: '#ffffff'
      })
    },
    print() {
      this.$print(this.$refs.print);
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 1181px;
  height: 1772px;
  background: #fff;
  padding: 60px;
  box-sizing: border-box;
  color: #000000 !important;

  div {
    box-sizing: border-box;
  }

  .content {
    width: 1061px;
    height: 1652px;
    background: #ffffff;
    border: 8px solid #000000;
    padding: 68px 80px 0 80px;

    .top {
      width: 100%;
      height: 400px;
      margin-bottom: 80px;

      .top-title {
        width: 821px;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 40px;

        .title-left {
          font-size: 80px;
          font-weight: 600;
          color: #000000;
        }

        .title-right {
          font-size: 45px;
          font-weight: 400;
          color: #000000;
        }
      }

      .top-text {
        width: 821px;
        height: 240px;
        font-size: 100px;
        font-weight: 600;
        color: #000000;
        line-height: 120px;
        margin-bottom: 80px;

        word-wrap: break-word;

      }
    }

    .middle {
      width: 100%;
      height: 436px;
      border-top: 8px solid #000000;
      border-bottom: 8px solid #000000;
      padding: 70px 0;
      box-sizing: border-box;

      div {
        width: 821px;
        height: 120px;
        line-height: 120px;
        font-size: 80px;

        font-weight: 600;
        color: #000000;

        &:first-child {
          margin-bottom: 40px;
        }
      }
    }

    .footer {
      width: 100%;
      height: 560px;
      padding-top: 40px;
      margin-bottom: 80px;
      box-sizing: border-box;

      div {
        width: 821px;
        height: 100px;
        font-size: 80px;

        font-weight: 600;
        color: #000000;
        line-height: 100px;

        // &:first-child {
        //   margin-bottom: 40px;
        // }
      }

      .box-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      // 条码保持原始比例，左右留白用于扫码，不挤占上方重量和尺寸。
      .box-barcode {
        display: block;
        max-width: 100%;
        height: 210px;
        margin: 12px auto 0;
      }
    }
  }
}
</style>
